import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const ServiceCard = ({ title, description, icon: Icon, link = '/services' }) => {
  return (
    <div 
      className="group relative bg-card border border-white/5 p-8 rounded-xl overflow-hidden transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_10px_40px_-10px_rgba(0,0,0,0.5)] hover:border-primary/30"
      data-aos="fade-up"
    >
      {/* Hover Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      
      <div className="relative z-10">
        <div className="w-14 h-14 rounded-lg bg-white/5 border border-white/10 flex items-center justify-center mb-6 group-hover:bg-primary group-hover:text-background transition-colors duration-500">
          {Icon && <Icon size={28} className="text-primary group-hover:text-background transition-colors duration-500" />}
        </div>
        
        <h3 className="text-xl font-serif font-bold text-foreground mb-4 group-hover:text-primary transition-colors duration-300">
          {title}
        </h3>
        
        <p className="text-muted-foreground mb-6 line-clamp-3">
          {description}
        </p>
        
        <Link to={link} className="inline-flex items-center text-sm font-semibold text-primary tracking-wide group/link">
          KNOW MORE
          <ArrowRight size={16} className="ml-2 transform group-hover/link:translate-x-1 transition-transform" />
        </Link>
      </div>
    </div>
  );
};

export default ServiceCard;
